import request from '@/utils/request.js'

/*******获取供应商列表********/
export function getSupplierListPage(data){
    return request({
        url: 'simSupplier/list',
        method: 'post',
        data
    })
}
/*******新增供应商********/
export function addAccount(data){
    return request({
        url: 'simSupplier/insert',
        method: 'post',
        data
    })
}
/*******编辑供应商********/
export function editAccount(data){
    return request({
        url: 'simSupplier/update',
        method: 'post',
        data
    })
}

// export function getAccountInfo(data){
//     return request({
//         url: 'sim/supplier/detail',
//         method: 'post',
//         data
//     })
// }

// export function changeAccountState(data){
//     return request({
//         url: 'sim/supplier/state',
//         method: 'post',
//         data
//     })
// }

// export function getBranchSupplierList(data){
//     return request({
//         url: 'sim/supplier/list',
//         method: 'post',
//         data
//     })
// }



/***平台获取公告列表***/
export function getNotifyListPage(data){
    return request({
        url: 'notice/list',
        method: 'post',
        data
    })
}
/***平台发布公告***/
export function publishNotify(data){
    return request({
        url: 'notice/add',
        method: 'post',
        data
    })
}
/***平台删除公告***/
export function deleteNotify(data){
    return request({
        url: 'notice/delete',
        method: 'post',
        data
    })
}
/***代理商获取公告列表***/
export function getAgentNotifyListPage(data){
    return request({
        url: 'agentNotice/list',
        method: 'post',
        data
    })
}
/***代理商删除公告***/
export function agentDeleteNotify(data){
    return request({
        url: 'agentNotice/delete',
        method: 'post',
        data
    })
}
/***登录显示公告***/
export function agentHomeNotify(data){
    return request({
        url: 'agentNotice/new/notice',
        method: 'post',
        data
    })
}
/***登录显示公告标记为已读***/
export function agentHomeNotifyReaded(data){
    return request({
        url: 'agentNotice/udapte',
        method: 'post',
        data
    })
}

// export function getFeedbackListPage(data){
//     return request({
//         url: 'userProblem/list',
//         method: 'post',
//         data
//     })
// }
// export function deleteFeedback(data){
//     return request({
//         url: 'userProblem/delete',
//         method: 'post',
//         data
//     })
// }
// export function replayFeedback(data){
//     return request({
//         url: 'userProblem/replay',
//         method: 'post',
//         data
//     })
// }
// export function exportFeedback(data){
//     return request({
//         url: 'problemOrOrder/readExcels',
//         method: 'get',
//         data
//     })
// }
// /***获取实名认证列表*****/
// export function getUsersAuthList(data){
//     return request({
//         url: 'authNickname/list',
//         method: 'post',
//         data
//     })
// }

// /***实名认证审核*****/
// export function userVerified(data){
//     return request({
//         url: 'authNickname/auth',
//         method: 'post',
//         data
//     })
// }